export default {"src":"/_next/static/media/music.61037818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};